import type { ProNotificationLinkInput } from '../../utils/proNotificationLinks';

/**
 * Deep-link paths for citizen push-notification taps. Mirrors the Pro resolver
 * but targets the `/citizen/*` routes. The citizen workspace is hidden, so
 * bill notifications go straight to the bill detail screen; everything else
 * falls back to the notifications list (handled by the caller's fallbackRoute).
 */
export function getCitizenNotificationLink(n: ProNotificationLinkInput): string | null {
  const type = n.notification_type || '';

  if (type.includes('bill')) {
    return n.entity_id ? `/citizen/bill/${n.entity_id}` : null;
  }
  if (type.includes('election') || type.includes('reminder')) {
    return '/citizen/voting';
  }
  if (type.includes('calendar') || type.includes('event')) {
    return '/citizen/briefing';
  }
  if (type.includes('survey') || type.includes('outreach')) {
    return n.entity_id ? `/citizen/requests/${n.entity_id}` : '/citizen/requests';
  }
  return null;
}
